import * as React from 'react';
import XmlFaktura from './Components/XmlFaktura';
import ImgFaktura from './Components/ImgFaktura';
import { getServerURL } from '../../Utils/getServerURL';
import { FakturabildFormat } from '../../Features/Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Components/VerifikationModal/Queries/VerifikationQuery/VerifikationQuery';
import EDBox from '../../BaseComponents/EDBox/EDBox';

interface IProps {
  fakturaBilder: string[];
  xmlFaktura?: boolean | null;
  title: string;
  skannadSvefaktura: boolean;
  noFullscreenToggle?: boolean;
  extraBottomPadding?: boolean;
  xmlFakturaFormat?: FakturabildFormat;
  verifikationsNr?: string;
  bildUrls?: string[];
  centeredImage?: boolean;
  fakturaId?: string | null;
  useWheelToScroll: boolean;
  ignoreFloatingMenu?: boolean;
}

export const Fakturabild: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { fakturaBilder, xmlFaktura } = props;

  if (!fakturaBilder) {
    return null;
  }

  return (
    <EDBox
      sx={{
        height: '100%',
        position: 'relative',
        ...(xmlFaktura &&
          !props.skannadSvefaktura &&
          props.xmlFakturaFormat === 'SVEFAKTURA' && { overflowX: 'scroll' }),
      }}
    >
      {xmlFaktura && !props.skannadSvefaktura && (
        <XmlFaktura
          url={`${getServerURL()}/blob?id=${fakturaBilder[0]}`}
          title={props.title}
          noFullscreenToggle={props.noFullscreenToggle}
          extraBottomPadding={props.extraBottomPadding}
          useWheelToScroll={props.useWheelToScroll}
          xmlFakturaFormat={props.xmlFakturaFormat}
          verifikationsNr={props.verifikationsNr}
          ignoreFloatingMenu={props.ignoreFloatingMenu}
        />
      )}
      {(!xmlFaktura || props.skannadSvefaktura) && (
        <ImgFaktura
          bildUrls={props.bildUrls}
          centeredImage={props.centeredImage}
          fakturaBilder={fakturaBilder}
          title={props.title}
          noFullscreenToggle={props.noFullscreenToggle}
          extraBottomPadding={props.extraBottomPadding}
          showCenteredImageToggle
          skannadSvefaktura={props.skannadSvefaktura}
          verifikationsNr={props.verifikationsNr}
          useWheelToScroll={props.useWheelToScroll}
          fakturaId={props.fakturaId}
          ignoreFloatingMenu={props.ignoreFloatingMenu}
        />
      )}
    </EDBox>
  );
};

export default Fakturabild;
